/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseNavigationMenuPrimaryItemFragment} from '@amblique/contentful/app/contentful/fragments/navigation-menu-primary-item/base-navigation-menu-primary-item.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';
import {BaseMenuItemFragment} from '@amblique/contentful/app/contentful/fragments/menu-item/base-menu-item.fragment';

export const NavigationMenuPrimaryItemFragment = gql`
  ${BaseLinkFragment}
  ${BaseMenuItemFragment}
  ${BaseNavigationMenuPrimaryItemFragment}

  fragment NavigationMenuPrimaryItemFragment on NavigationMenuPrimaryItem {
    ...BaseNavigationMenuPrimaryItemFragment

    menuItemsCollection {
      items {
        __typename
        ... on MenuItem {
          ...BaseMenuItemFragment
        }
      }
    }
    menuItemsCursorCollection {
      items {
        __typename
        ... on MenuItem {
          ...BaseMenuItemFragment
        }
      }
    }
    promotionalLinksCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
    promotionalLinksCursorCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
  }
`;
